export const NAMESPACE = 'global-loader';
